import { useEffect, useState } from 'react';

/**
 * Сколько снизу экрана занимает нижнее меню — от его верхнего края до низа.
 *
 * Меряем, а не берём константу: высота меню зависит от системной врезки
 * (`env(safe-area-inset-bottom)`, см. BottomNavigation.css). На Android
 * с кнопочной навигацией она около 48px, и константа 90px оставляла
 * липкие панели под меню.
 *
 * Пока открыто окно, меню уезжает вниз (`--hidden`) — в это время
 * не перемеряем, иначе панели прыгнули бы на высоту меню.
 */
const useNavOffset = (fallback = 90) => {
  const [navOffset, setNavOffset] = useState(fallback);

  useEffect(() => {
    const measure = () => {
      const nav = document.querySelector('.bottom-navigation');
      if (nav && !nav.classList.contains('bottom-navigation--hidden')) {
        setNavOffset(Math.max(0, window.innerHeight - nav.getBoundingClientRect().top));
      }
    };
    measure();
    // Меню монтируется вместе со страницей — первый замер может прийти
    // раньше его вёрстки
    const timer = setTimeout(measure, 300);
    window.addEventListener('resize', measure);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', measure);
    };
  }, []);

  return navOffset;
};

export default useNavOffset;
